import { render, staticRenderFns } from "./ConfigHistory.vue?vue&type=template&id=cc9826bc&scoped=true"
import script from "./ConfigHistory.vue?vue&type=script&lang=js"
export * from "./ConfigHistory.vue?vue&type=script&lang=js"
import style0 from "./ConfigHistory.vue?vue&type=style&index=0&id=cc9826bc&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc9826bc",
  null
  
)

export default component.exports